import G2 from '@antv/g2'
export default {
  data () {
      return {
          data:[{
              institution: '茂名市第十六中学',
              prices: 38656.32,
              date:'2018年07月17日',
              invoice:'35545048-35545051',
              remark:'普通发票'
            },{
              institution: '化州市平定中学',
              prices: 37071.85,
              date:'2018年07月17日',
              invoice:'35545060-35545063',
              remark:'普通发票'
            },{
              institution: '郑州市人才市场',
              prices: 371577.75,
              date:'2018年08月08日',
              invoice:'34466005-35545262',
              remark:'普通发票'
            },{
              institution: '信宜市第一小学',
              prices: 21809.71,
              date:'2018年08月15日',
              invoice:'19799748-197997500',
              remark:'电子普通发票'
            },{
              institution: '化州市第三中学',
              prices: 22071.85,
              date:'2018年08月28日',
              invoice:'34466077-34466079',
              remark:'普通发票'
            },{
              institution: '化州市合江中学',
              prices: 43514.57,
              date:'2018年08月28日',
              invoice:'34466083-34466087',
              remark:'普通发票'
            },{
              institution: '广东有色金属地质局水文地质队',
              prices: 38656.32,
              date:'2018年08月28日',
              invoice:'34466089-34466090',
              remark:'普通发票'
            },{
              institution: '清远职业技术学院',
              prices: 89040.80,
              date:'2018年08月28日',
              invoice:'34466102-34466117',
              remark:'普通发票'
            },{
              institution: '郑州市人才市场',
              prices: 38834.96,
              date:'2018年08月30日',
              invoice:'34466236-34466239',
              remark:'普通发票'
            },{
              institution: '广东博大高速公路有限公司博深分公司',
              prices: 15145.64,
              date:'2018年09月03日',
              invoice:'34466312-34466338',
              remark:'普通发票'
            },{
              institution: '信宜市丁堡职业高级中学',
              prices: 48652.44,
              date:'2018年09月10日',
              invoice:'34466354-34466359',
              remark:'普通发票'
            },{
              institution: '化州市第三中学',
              prices: 41755.35,
              date:'2018年09月19日',
              invoice:'34466521-34466525',
              remark:'普通发票'
            },{
              institution: '广深珠高速公路有限公司',
              prices: 34211.37,
              date:'2018年09月25日',
              invoice:'34466558-34466563',
              remark:'普通发票'
            },{
              institution: '高州市石鼓第一中学',
              prices: 48322.04,
              date:'2018年09月26日',
              invoice:'34466573-34466578',
              remark:'普通发票'
            },{
              institution: '化州市官桥中学',
              prices: 102809.73,
              date:'2018年10月10日',
              invoice:'34466680-34466690',
              remark:'普通发票'
            },{
              institution: '湛江市第二十中学',
              prices: 84912.64,
              date:'2018年10月11日',
              invoice:'19800194-19800202',
              remark:'电子普通发票'
            },{
              institution: '揭阳广播电视台',
              prices: 28234.96,
              date:'2018年10月25日',
              invoice:'34466757-34466761',
              remark:'普通发票'
            },{
              institution: '雷州市实验小学',
              prices: 44400.01,
              date:'2018年10月26日',
              invoice:'34466778-34466761',
              remark:'普通发票'
            },{
              institution: '郑州畅和教育科技有限公司',
              prices: 439654.47,
              date:'2018年10月29日',
              invoice:'34466794-34466840',
              remark:'普通发票'
            },{
              institution: '广东省有色金属地质局水文地质队',
              prices: 17266.02,
              date:'2018年10月31日',
              invoice:'19800351-19800352',
              remark:'电子普通发票'
            },{
              institution: '揭阳广播电视台',
              prices: 28234.96,
              date:'2018年10月31日',
              invoice:'34466869-34466873',
              remark:'普通发票'
            },{
              institution: '信宜市实验学校',
              prices: 66646.61,
              date:'2018年10月31日',
              invoice:'34466889-34466896',
              remark:'普通发票'
            },{
              institution: '广东省有色金属地质局水文地质队',
              prices: 17266.02,
              date:'2018年11月06日',
              invoice:'19800432-19800433',
              remark:'电子普通发票'
            },{
              institution: '佛山市粤运公共交通有限公司',
              prices: 55825.25,
              date:'2018年11月16日',
              invoice:'19800590-19800595',
              remark:'电子普通发票'
            },{
              institution: '郑州市人才市场',
              prices: 299052.49,
              date:'2018年11月16日',
              invoice:'34466956-34466986',
              remark:'普通发票'
            },{
              institution: '揭阳市揭东区第二中学',
              prices: 41592.24,
              date:'2018年11月16日',
              invoice:'34467018-34467022',
              remark:'普通发票'
            },{
              institution: '化州市第九中学',
              prices: 44691.27,
              date:'2018年11月27日',
              invoice:'34467205-34467209',
              remark:'普通发票'
            },{
              institution: '廉江市教师进修学校',
              prices: 671592.20,
              date:'2018年12月04日',
              invoice:'34467229-34467298',
              remark:'普通发票'
            },
          ],
      }
  },
  methods: {
      draw(){
          var data = this.data
          var chart = new G2.Chart({
              container: 'draw1',
              forceFit: true,  
              padding:'auto',
              height: 400
          });
          chart.source(data);
          chart.axis('institution', {
              label: {
                  offset: 12
              }
          });
          chart.coord().transpose();
          chart.scale('prices', {
              alias: '金额(元)',
          });
          chart.scale('date', {
              alias: '日期',
          });
          chart.scale('remark', {
              alias: '备注',
          });
          chart.scale('invoice', {
              alias: '发票号码',
          });
          chart.interval().position('institution*prices').tooltip('prices*date*invoice*remark');
          chart.render();
      },
      drawring(){
          var data = this.data
          var chart = new G2.Chart({
              container: 'draw2',
              forceFit: true,
              height: 400,
              padding:'auto',
              animate: false
          });
          chart.source(data);
          chart.coord('theta', {
              radius: 0.75,
              innerRadius: 0.6
          });
          chart.scale('institution', {
              alias: '培训单位',
          });
          chart.scale('prices', {
              alias: '金额(元)',
          });
          chart.scale('date', {
              alias: '日期',
          });
          chart.scale('remark', {
              alias: '备注',
          });
          chart.scale('invoice', {
              alias: '发票号码',
          });
          chart.tooltip({
              showTitle: false
          });
          // 辅助文本
          chart.guide().html({
              position: ['50%', '50%'],
              html: '<div style="color:#8c8c8c;font-size: 14px;text-align: center;width: 10em;">合计：<br><span style="color:#8c8c8c;font-size:20px">2839576.14</span>元</div>',
              alignX: 'middle',
              alignY: 'middle'
          });
          var interval = chart.intervalStack().position('prices').tooltip('institution*prices*date*invoice*remark').color('#0a75d8').label('prices', {
              formatter: function formatter(val, item) {
                  return item.point.institution + ': ' + val + '元';
              }
          }).style({
              lineWidth: 1,
              stroke: '#fff'
          });
          chart.render();
          // interval.setSelected(data[0]);
      }
  },
  mounted(){
      this.draw()
      this.drawring()
  }
}